import styled from 'styled-components'


export const SC_Content = styled.div`
  img {
    max-width: 100%;
    height: auto;
    border-radius: 12px;
    margin: 8px 0;
  }

  p {
    margin-top: 12px;
    margin-bottom: 12px;
    line-height: 1.5;
  }

  figure.image {
    margin: 16px 0;

    img {
      width: 100%;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    figcaption {
      text-align: center;
      font-size: 12px;
      color: #999;
      margin-top: 4px;
    }
  }
`
